<template>
  <div>
    <h3>{{ t('service') }}</h3>
    <div v-for="(extra, i) in extras" :key="i">
      <div class="font-medium">{{ t('price') }}: <span v-currency="extra.price" /></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Car } from '@/entities/cars/car.entity';
import type { CreateBookingProps } from '@/views/bookings/booking-create/components/use-create-booking-props';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { VehicleExtraType } from '@carvia/ros-client-types';
import { getCustomBookedExtras } from '@/utils/pricing.utils';

const props = defineProps<{
  car: Car;
  createBookingProps: CreateBookingProps;
}>();

const { pricing } = props.createBookingProps;
const { t } = useI18n();

const extras = computed(() =>
  pricing.value
    ? getCustomBookedExtras(pricing.value).filter(
        (extra) => extra.customVehicleExtraType === VehicleExtraType.EMERGENCY_SERVICE,
      )
    : undefined,
);
</script>

<i18n lang="json">
{
  "en": {
    "service": "Emergency Service",
    "price": "Price"
  },
  "de": {
    "service": "Notdienstgebühr",
    "price": "Preis"
  },
  "es": {
    "service": "Servicio de urgencias",
    "price": "Precio"
  }
}
</i18n>
